import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { FsaPermission } from "../../../../../../../Wrap/Models/Models/Company/FsaPermission";
import { CompanyWizardAction } from "../../../../../../Admin/Company/CompanyWizard/Actions/CompanyWizardAction";
import { Alert } from "../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../Shared/Entities/Constants/AlertConstants";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { ClientAccountStore } from "../../../../../Stroes/Variable";
import { SubAccountTypeHelper } from "../../../Common/Helpers/SubAccountTypeHelper";
import { IsaAllowance } from "../../../Common/ISA/PaymentsIn/IsaAllowance";
import { BankAccountAction } from "../../../Common/PaymentsIn/BankAccount/BankAccountAction";
import { inUseBankAccountForContribution } from "../../../Common/PaymentsIn/BankAccount/BankAccountHelper";
import { FinancialAdvice } from "../../../Common/PaymentsIn/FinancialAdvice";
import { RegularPayment } from "../../../Common/PaymentsIn/RegularPayment/RegularPayment";
import { MoneyPurchaseAnnualAllowanceComponent } from "../../../Common/PaymentsIn/SIPP/MoneyPurchaseAnnualAllowanceComponent";
import { PensionProtection } from "../../../Common/PaymentsIn/SIPP/PensionProtection";
import { isRestrictedToPensionContribution } from "../../../Common/PaymentsIn/SIPP/ValidationHelper";
import { IsRestrictedToPensionContributionWarningText, PaymentType, processTypeEnum } from "../../../Common/Resource/Contents";
import { ProductOverviewPaymentsInAction } from "../../../PortfolioDashboard/Components/ProductOverview/Action/ProductOverviewPaymentsInAction";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { PendingPaymentInModel } from "../../../../../../../Wrap/Models/Models/Payments/Deposits/PendingPaymentInModel";
import { IsaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/OneOffPayment/Isa/IsaContributionModel";
import { WrapCashContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/WrapCash/WrapCashContributionModel";
import { PensionContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContributionModel";
import { GiaContributionModel } from "../../../../../../../Wrap/Models/Models/Processes/Apply/PersonalPortfolio/GiaContributionModel";
import { PensionContribution } from "../../../../../../../Wrap/Models/Models/Processes/Apply/Pension/PensionContribution";
import { IsaContribution } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/Isa/IsaContribution";
import { ProcessType } from "../../../../../../Shared/IST/Resource/Content";
import { PensionAnnuityAssumption } from "../../../Common/PaymentsIn/SIPP/PensionAnnuityAssumption";

interface IPaymentsInProps extends IProcessComponentProps {
    type: SubAccountType;
    data: IsaContributionModel | WrapCashContributionModel | PensionContributionModel |  GiaContributionModel;
    hasCashIsa?: boolean;
    isEdit?: boolean;
    customerId?: number;
    autoLineCompleted?: boolean;
}

interface IPaymentsInState {
    disableJourney: boolean;
    pendingPaymentsIn?: Array<PendingPaymentInModel>;
}

export class PaymentsIn extends ProcessComponent<IPaymentsInProps, IPaymentsInState> {
    public static defaultProps = {
        autoLineCompleted: true,
    };
    constructor(props: any) {
        super(props);
        this.state = {
            disableJourney: false,
            pendingPaymentsIn: null,
        };
    }

    componentDidMount(): void {
        super.componentDidMount();
        CompanyWizardAction.getCompanyFsaPermissionDetail(
            ClientAccountStore.getClientAccountInfo()?.Company, "AdviseInvestments",
            (result: FsaPermission[]) => {
                if (
                    !result.some(
                        (ele) =>
                            ele.FsaRegulatedActivity?.Name?.toLowerCase() == "AdviseInvestments".toLowerCase() &&
                            ele?.IsInclude &&
                            ele?.IsPermit
                    )
                ) {
                    this.setState({ disableJourney: true });
                }
            }
        );

        const subAccountHierarchyId = getQueryParameters()["subaccounthierarchyid"];

        ProductOverviewPaymentsInAction.getPendingProductPaymentsIn(
            subAccountHierarchyId,
            (data: Array<PendingPaymentInModel>) => {
                this.setState({ pendingPaymentsIn: data });
            }
        );
    }

    private renderFsaError() {
        if (this.state.disableJourney) {
            return <Alert message={"FCA Permissions prevents the following action."} alertType={AlertType.Error} />;
        }
        return <></>;
    }

    isValid() {
        const flag = super.isValid();
        var isRestrictedProtection = false;
        const hasContribution = this.atLeastOneContribution();
        if (!hasContribution) {
            this.props.showErrorMsgPopUp(["Please make a contribution to this product wrapper to continue."]);
        }
        if ((this.props.data?.Contribution as PensionContribution)?.HasPensionProtection && (this.props.data?.Contribution as PensionContribution)?.PensionProtection) {
            isRestrictedProtection = isRestrictedToPensionContribution(
                (this.props.data?.Contribution as PensionContribution)?.PensionProtection 
            );
            if (isRestrictedProtection) {
                this.props.showErrorMsgPopUp([IsRestrictedToPensionContributionWarningText]);
            }
        }

        return flag && hasContribution && !this.state.disableJourney && !isRestrictedProtection;
    }

    private atLeastOneContribution(): boolean {
        const { data } = this.props;

        return (
            data.Contribution.ClientRegularPayment?.Money?.Amount > 0 ||
            data.Contribution.ThirdPartyRegularPayment?.Money?.Amount > 0 ||
            (data.Contribution  as PensionContribution).EmployerRegularPayment?.Money?.Amount > 0 ||
            (data.Contribution  as PensionContribution).EmployerSalaryDeductionRegularPayment?.Money?.Amount > 0
        );
    }

    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            hasPaymentMethod: true,
            onSaveNewBankAccountInstruction: (bankAccountInstruction) => {
                bankAccountInstruction.OwnerHierarchyId = data.OwnerHierarchyId;
                BankAccountAction.saveBankInstruction(
                    bankAccountInstruction,
                    this.props.customerId,
                    processTypeEnum.RegularPayment,
                    (savedBankAccountInstruction) => {
                        const changes = [...data.BankAccountInstructions, ...[savedBankAccountInstruction]];
                        this.onDataChange(onChange, changes, data, "BankAccountInstructions");
                    }
                );
            },
            onRemoveBankAccountInstruction: (bankAccountInstruction) => {
                BankAccountAction.removeBankInstruction(bankAccountInstruction, () => {
                    const changes = (data.BankAccountInstructions || []).filter(
                        (x) => x.AccountNumber != bankAccountInstruction.AccountNumber
                    );
                    this.onDataChange(onChange, { BankAccountInstructions: changes }, data);
                });
            },
            inUseBankAccountInstruction: inUseBankAccountForContribution(data?.Contribution),
        };
    };

    public render(): JSX.Element {
        const { Contribution } = this.props.data;
        const { isEdit } = this.props;
        return (
            <div>
                {this.renderFsaError()}
                <h2>Payments in</h2>
                <FinancialAdvice
                    {...this.getProps("Contribution")}
                    readonly={this.state.disableJourney || !this.props.autoLineCompleted}
                    processtype={isEdit?ProcessType.EditRegular:ProcessType.AddRegular}
                />
                {Contribution?.AdviceGiven != null && this.renderPaymentsIn()}
            </div>
        );
    }

    private renderPaymentsIn() {
        const { ClientDetails, AllBankAccounts, BankAccountInstructions, Contribution } = this.props.data;
        const { type, isEdit } = this.props;
        if (SubAccountTypeHelper.isWrapCash(type) || SubAccountTypeHelper.isPP(type)) {
            return (
                <>
                    <hr />
                    <RegularPayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        pendingPaymentsIn={this.state?.pendingPaymentsIn}
                        processType={processTypeEnum.RegularPayment}
                        isEdit={isEdit}
                        autoLineCompleted={this.props.autoLineCompleted}
                    />
                </>
            );
        } else if (SubAccountTypeHelper.isIsa(type)) {
            return (
                <>
                    <hr />
                    {(Contribution  as IsaContribution).IsaAllowance && <IsaAllowance {...this.getProps("Contribution")} isRegular={true} />}
                    <hr />
                    <RegularPayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty]}
                        hasPaymentMethod={true}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        pendingPaymentsIn={this.state?.pendingPaymentsIn}
                        processType={processTypeEnum.RegularPayment}
                        isEdit={isEdit}
                        autoLineCompleted={this.props.autoLineCompleted}
                    />
                </>
            );
        } else if (SubAccountTypeHelper.isOnPlatformPension(type)) {
            return (
                <>
                    <hr />
                        { type != SubAccountType.JuniorSipp && (
                        <>
                        <MoneyPurchaseAnnualAllowanceComponent {...this.getProps("Contribution")} /> 
                        <PensionProtection 
                            label={"Edit pension protection"} 
                            {...this.getProps("Contribution")} />
                        </>
                        )}
                        <PensionAnnuityAssumption 
                            {...this.getProps("Contribution")} 
                            processType={ isEdit ? ProcessType.EditRegular : ProcessType.AddRegular} />
                    <hr />
                    <RegularPayment
                        {...this.getProps("Contribution")}
                        clientInfo={ClientDetails}
                        checkBoxOption={[
                            PaymentType.Client,
                            PaymentType.ThirdParty,
                            PaymentType.EmployerSalaryDeduction,
                            PaymentType.Employer,
                        ]}
                        hasPaymentMethod={true}
                        subAccountType={this.props.type}
                        bankAccounts={AllBankAccounts}
                        bankAccountInstructions={BankAccountInstructions}
                        pendingPaymentsIn={this.state?.pendingPaymentsIn}
                        processType={processTypeEnum.RegularPayment}
                        isEdit={isEdit}
                        autoLineCompleted={this.props.autoLineCompleted}
                    />
                </>
            );
        }
    }
}
